// import { InputSelect } from "#common/componentes/Inputs"
import { MasterDialog } from "#common/Dialog/Dialog"
// import { InputAutocomplete } from "#common/input/InputAutocomplete"
import InputText from "#common/input/InputText"
import { SkeletonSquare } from "#common/Skeleton"
import { UseContextsCompetence } from "#competence/contexts/ContextsCompetence"
import { CategoryGet, competencePost, CompetencePut } from "#competence/services/Api"
import InputSelect from "#core/components/input/select/InputSelect"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import { Stack } from "@mui/material"
import { Fragment, useCallback, useEffect, useMemo, useState } from "react"

const dataBase = { name: "", description: "", category: "", dimensiones: "" }

export default function CompetenceForm({ open, setOpen, competence }) {
	const { refresh } = UseContextsCompetence()
	const [form, setForm] = useState(dataBase)
	const [disabled, setDisabled] = useState(false)
	const [disabledCancelar, setDisabledCancelar] = useState(false)
	const edit = useMemo(() => !!competence?.id, [competence?.id])

	const params = useMemo(() => ({ list: true }), [])
	const { data: categories, loading: loadingCategories } = useApi(CategoryGet, {
		autoFetch: open,
		params,
	})

	const success = () => {
		refresh()
		setOpen(false)
		setForm(dataBase)
	}
	const end = () => {
		setDisabled(false)
		setDisabledCancelar(false)
	}
	const { fetch: post } = useApiSend(competencePost, { success, end })
	const { fetch: put } = useApiSend(CompetencePut, { success, end })

	const fetch = useCallback(
		(data) => {
			if (edit) put(competence.id, data)
			else post(data)
		},
		[competence, edit, post, put]
	)

	useEffect(() => {
		if (
			form.name.trim() === "" ||
			form.description.trim() === "" ||
			form.dimensiones.trim() === "" ||
			form.category === ""
		) {
			setDisabled(true)
			return
		}
		setDisabled(false)
	}, [form.category, form.description, form.dimensiones, form.name, refresh])

	const buttons = useMemo(() => {
		return [
			{
				label: "Cancelar",
				onClick: () => {
					setForm(dataBase)
					setOpen(false)
				},
				disabled: disabledCancelar,
			},
			{
				label: "Guardar",
				onClick: () => {
					setDisabled(true)
					setDisabledCancelar(true)
					fetch(form)
				},
				disabled,
			},
		]
	}, [disabled, disabledCancelar, fetch, form, setOpen])

	useEffect(() => {
		if (competence?.id) {
			setForm({ ...competence })
		}
	}, [competence])

	return (
		<Fragment>
			<MasterDialog
				{...{
					open,
					setOpen,
					title: `${edit ? "Editar" : "Agregar"} competencia`,
					buttons,
				}}
				maxWidth="md"
			>
				<Stack spacing={2} sx={{ width: "100%" }}>
					<InputText
						label="Nombre"
						name="name"
						required
						fullWidth
						value={form.name}
						setValue={(data) => setForm({ ...form, name: data })}
						multiline
						minRows={1}
						maxRows={3}
					/>
					<InputText
						label="Descripción"
						name="description"
						required
						fullWidth
						multiline={true}
						rows={4}
						value={form.description}
						setValue={(data) => setForm({ ...form, description: data })}
					/>
					<InputSelect
						label="Categoría"
						options={categories?.data || []}
						optionsId="id"
						optionsLabel="name"
						value={form.category}
						required
						description={"description"}
						setValue={(data) => {
							setForm({ ...form, category: data })
						}}
						loading={loadingCategories}
					/>
					<InputText
						label="Dimensiones"
						name="dimensiones"
						fullWidth
						required
						multiline={true}
						rows={5}
						value={form.dimensiones}
						setValue={(data) => setForm({ ...form, dimensiones: data })}
					/>
				</Stack>
			</MasterDialog>
		</Fragment>
	)
}
